<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                <v-icon class="me-2">mdi-filter</v-icon>
                                Search Form
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="pa-2">
                                        <v-col md="3" cols="12">
                                            <v-autocomplete
                                                label="Search Product Name"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="product_id.value.value"
                                                :items="getProductMapList"
                                                :item-title="(item) => `${item.product.name}`"
                                                item-value="product_id"
                                                autocomplete="off"
                                                clearable
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col md="3" cols="12">
                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="From Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="from_date.value.value"
                                                :error-messages="from_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>
                                        </v-col>
                                        <v-col md="3" cols="12">
                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="To Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="to_date.value.value"
                                                :error-messages="to_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>
                                        </v-col>
                                        <v-col lg="2" md="2" cols="12">
                                            <v-btn
                                                class="bg-brand w-15"
                                                type="submit"
                                                ref="searchButton"
                                            >Search</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>           
        </v-container>

        <v-container fluid style="margin-top: -20px;">
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header"
                            >
                            <v-icon class="me-2">mdi-file-question</v-icon>
                            RFQ Generation Report
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-row class="py-2">
                                    <v-col md="4" cols="6">
                                        <v-text-field
                                        v-model="search"
                                        append-inner-icon="mdi-magnify"
                                        label="Search"
                                        single-line
                                        hide-details
                                        density="compact"
                                        variant="outlined"
                                        bg-color="grey-lighten-4"
                                        class="pl-2"
                                        clearable
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="4" cols="6">
                                        <v-btn-group
                                            variant="outlined"
                                            density="compact"
                                            size="x-small"
                                            divided
                                            >
                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="success"
                                                @click="exportToCSV"
                                                :disabled="getSchema.length === 0"
                                                >CSV</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="primary"
                                                @click="exportToExcel"
                                                :disabled="getSchema.length === 0"
                                                >EXCEL</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="red"
                                                @click="exportToPDF"
                                                :disabled="getSchema.length === 0"
                                                >PDF</v-btn>
                                            </v-btn-group>
                                    </v-col>
                                </v-row>
                                
                                <div v-if="!getSchema.length && !loading" class="py-6 text-center text-medium-emphasis">
                                    <v-icon size="64" color="grey-lighten-1" class="mb-2">mdi-file-remove</v-icon>
                                    <div class="text-h6 text-grey mt-4">No RFQ Data Found</div>
                                    <div class="text-body-2 text-grey">Try adjusting filters or search criteria</div>
                                </div>

                                <v-data-table
                                    v-else
                                    :headers="headers"
                                    :items="getSchema"
                                    :loading="loading"
                                    v-model:items-per-page="itemsPerPage"
                                    :search="search"
                                    :hover="true"
                                    density="compact"
                                    >
                                    <template v-slot:item.index="{ index }">
                                        {{ ++index }}
                                    </template>
                                    <template v-slot:item.rfqMaster.code="{ item }">
                                        <v-chip
                                            size="small"
                                            color="primary"
                                            variant="outlined"
                                        >
                                            {{ item.rfq_master?.code || item.rfqMaster?.code || 'N/A' }}
                                        </v-chip>
                                    </template>
                                    <template v-slot:item.rfq_date="{ item }">
                                        {{ formatDateDash(item.rfq_date) }}
                                    </template>
                                    <template v-slot:item.rfqMaster.requisition.code="{ item }">
                                        {{ item.rfq_master?.requisition?.code || item.rfqMaster?.requisition?.code || 'N/A' }}
                                    </template>
                                    <template v-slot:item.product.name="{ item }">
                                        {{ item.product?.name || 'N/A' }}
                                    </template>
                                    <template v-slot:item.product.code="{ item }">
                                        {{ item.product?.code || 'N/A' }}
                                    </template>
                                    <template v-slot:item.product.unit.name="{ item }">
                                        {{ item.product?.unit?.name || 'N/A' }}
                                    </template>
                                    <template v-slot:item.product.secondaryUnit.name="{ item }">
                                        {{ item.product?.secondary_unit?.name || item.product?.secondaryUnit?.name || 'N/A' }}
                                    </template>
                                    <template v-slot:item.rfqMaster.created_by.full_name="{ item }">
                                        {{ item.rfq_master?.created_by?.full_name || item.rfqMaster?.created_by?.full_name || 'N/A' }}
                                    </template>
                                    <template v-slot:item.rfqMaster.approvalProcess.approvedBy.full_name="{ item }">
                                        {{ getApprovedByNames(item) }}
                                    </template>
                                </v-data-table>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>

    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, computed } from "vue";
import { toast } from "vue3-toastify";
import { formatDateView, formatDateDash } from "@/plugins/helpers";
import formattedDate from "@/plugins/dateFormatter";

export default {
    data: () => ({
        itemsPerPage: -1,
        panel: [0],
        panel2: [0],
        search: "",
        headers: [
            { title: "#SL", key: "index", align: "center", width: "5%", sortable: false },
            { title: "RFQ Code", key: "rfqMaster.code", align: "left", sortable: false, width: "120px" },
            { title: "RFQ Date", key: "rfq_date", align: "left", sortable: false, width: "120px" },
            { title: "Requisition Code", key: "rfqMaster.requisition.code", align: "left", sortable: false, width: "150px" },
            { title: "Product Code", key: "product.code", align: "left", sortable: false, width: "120px" },
            { title: "Product Name", key: "product.name", align: "left", sortable: false, width: "200px" },
            { title: "Quantity", key: "qty", align: "right", sortable: false, width: "100px" },
            { title: "Unit", key: "product.unit.name", align: "left", sortable: false, width: "100px" },
            { title: "Secondary Unit", key: "product.secondaryUnit.name", align: "left", sortable: false, width: "120px" },
            { title: "Rate", key: "rate", align: "right", sortable: false, width: "100px" },
            { title: "Amount", key: "amount", align: "right", sortable: false, width: "120px" },
            { title: "Created By", key: "rfqMaster.created_by.full_name", align: "left", sortable: false, width: "150px" },
            { title: "Approved By", key: "rfqMaster.approvalProcess.approvedBy.full_name", align: "left", sortable: false, width: "150px" },
        ],
    }),
    created() {
        if (this.$store.getters.getProductMapList.length == 0) {
            this.loading = true;
            this.$store.dispatch("getProductMapList").then((response) => {
                this.loading = false;
            });
        }
    },
    computed: {
        getSchema() {
            return this.$store.getters.getPurRFQGenReport;
        },
        getProductMapList() {
            let data = this.$store.getters.getProductMapList;
            if (data.length > 0) {
                return data.filter((item) => item.status == 1);
            }
            return [];
        },
    },
    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                // Add your validation rules here
            }),
        });

        const product_id = useField("product_id");
        const from_date = useField("from_date");
        const to_date = useField("to_date");
        const loading = ref(false);
        const store = useStore();

        const submit = handleSubmit((values) => {
            loading.value = true;
            values.from_date = formattedDate(from_date.value.value);
            values.to_date = formattedDate(to_date.value.value);
            store
                .dispatch("getPurRFQGenReport", values)
                .then((response) => {
                    loading.value = false;
                    if (response.data.success) {
                        toast.success(response.data.message || "Data loaded successfully");
                    }
                })
                .catch((error) => {
                    loading.value = false;
                    toast.error(error?.response?.data?.message || "An error occurred");
                });
        });

        return {
            product_id,
            from_date,
            to_date,
            submit,
            loading,
        };
    },
    methods: {
        formatDateDash,
        formattedDate,
        getApprovedByNames(item) {
            const rfqMaster = item.rfq_master || item.rfqMaster;
            if (!rfqMaster) return 'N/A';
            
            const approvalProcess = rfqMaster.approval_process || rfqMaster.approvalProcess;
            if (!approvalProcess) return 'N/A';
            
            // Handle both array and single object
            const processes = Array.isArray(approvalProcess) ? approvalProcess : [approvalProcess];
            const names = processes
                .map(process => {
                    const approvedBy = process.approved_by || process.approvedBy;
                    return approvedBy?.full_name || null;
                })
                .filter(name => name);
            
            return names.length > 0 ? names.join(', ') : 'N/A';
        },
        exportToCSV() {
            if (!this.getSchema || this.getSchema.length === 0) {
                toast.warning('No data to export');
                return;
            }

            const columns = [
                "#SL",
                "RFQ Code",
                "RFQ Date",
                "Requisition Code",
                "Product Code",
                "Product Name",
                "Quantity",
                "Unit",
                "Secondary Unit",
                "Rate",
                "Amount",
                "Created By",
                "Approved By",
            ];

            let serialNum = 1;
            const rows = this.getSchema.map(item => [
                serialNum++,
                item.rfq_master?.code || item.rfqMaster?.code || "",
                formatDateDash(item.rfq_date),
                item.rfq_master?.requisition?.code || item.rfqMaster?.requisition?.code || "",
                item.product?.code ?? "",
                item.product?.name ?? "",
                item.qty ?? 0,
                item.product?.unit?.name ?? "",
                item.product?.secondary_unit?.name || item.product?.secondaryUnit?.name || "",
                item.rate ?? 0,
                item.amount ?? 0,
                item.rfq_master?.created_by?.full_name || item.rfqMaster?.created_by?.full_name || "",
                this.getApprovedByNames(item),
            ]);

            const data = [columns, ...rows];
            const proxy = this.$appContext?.config?.globalProperties;
            if (proxy?.$exportTableToCSV && proxy?.$fileDate) {
                proxy.$exportTableToCSV(data, 'rfq_generation_report_' + proxy.$fileDate());
            } else if (this.$exportTableToCSV && this.$fileDate) {
                this.$exportTableToCSV(data, 'rfq_generation_report_' + this.$fileDate());
            }
        },
        exportToExcel() {
            if (!this.getSchema || this.getSchema.length === 0) {
                toast.warning('No data to export');
                return;
            }

            const data = [[
                "#SL",
                "RFQ Code",
                "RFQ Date",
                "Requisition Code",
                "Product Code",
                "Product Name",
                "Quantity",
                "Unit",
                "Secondary Unit",
                "Rate",
                "Amount",
                "Created By",
                "Approved By",
            ]];

            let serialNum = 1;
            this.getSchema.forEach(item => {
                data.push([
                    serialNum++,
                    item.rfq_master?.code || item.rfqMaster?.code || "",
                    formatDateDash(item.rfq_date),
                    item.rfq_master?.requisition?.code || item.rfqMaster?.requisition?.code || "",
                    item.product?.code ?? "",
                    item.product?.name ?? "",
                    item.qty ?? 0,
                    item.product?.unit?.name ?? "",
                    item.product?.secondary_unit?.name || item.product?.secondaryUnit?.name || "",
                    item.rate ?? 0,
                    item.amount ?? 0,
                    item.rfq_master?.created_by?.full_name || item.rfqMaster?.created_by?.full_name || "",
                    this.getApprovedByNames(item),
                ]);
            });

            const proxy = this.$appContext?.config?.globalProperties;
            if (proxy?.$exportTableToExcel && proxy?.$fileDate) {
                proxy.$exportTableToExcel(data, 'rfq_generation_report_' + proxy.$fileDate());
            } else if (this.$exportTableToExcel && this.$fileDate) {
                this.$exportTableToExcel(data, 'rfq_generation_report_' + this.$fileDate());
            }
        },
        exportToPDF() {
            if (!this.getSchema || this.getSchema.length === 0) {
                toast.warning('No data to export');
                return;
            }

            const columns = [
                "#SL",
                "RFQ Code",
                "RFQ Date",
                "Requisition Code",
                "Product Code",
                "Product Name",
                "Quantity",
                "Unit",
                "Secondary Unit",
                "Rate",
                "Amount",
                "Created By",
                "Approved By",
            ];

            let serialNum = 1;
            const rows = this.getSchema.map(item => [
                serialNum++,
                item.rfq_master?.code || item.rfqMaster?.code || "",
                formatDateDash(item.rfq_date),
                item.rfq_master?.requisition?.code || item.rfqMaster?.requisition?.code || "",
                item.product?.code ?? "",
                item.product?.name ?? "",
                item.qty ?? 0,
                item.product?.unit?.name ?? "",
                item.product?.secondary_unit?.name || item.product?.secondaryUnit?.name || "",
                item.rate ?? 0,
                item.amount ?? 0,
                item.rfq_master?.created_by?.full_name || item.rfqMaster?.created_by?.full_name || "",
                this.getApprovedByNames(item),
            ]);

            const proxy = this.$appContext?.config?.globalProperties;
            if (proxy?.$exportTableToPDF && proxy?.$fileDate) {
                proxy.$exportTableToPDF(columns, rows, "RFQ Generation Report", "rfq_generation_report_" + proxy.$fileDate());
            } else if (this.$exportTableToPDF && this.$fileDate) {
                this.$exportTableToPDF(columns, rows, "RFQ Generation Report", "rfq_generation_report_" + this.$fileDate());
            }
        },
    },
};
</script>

<style scoped>
.panel-header {
    font-weight: 600;
}
</style>

